import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import numberbeautify from "../../utils/numberbeautify";
import Editcustomermodal from "./editcustomermodal";
import Loanbackmodal from "./loanbackmodal";
import iqd_rounding from "../../utils/iqd_rounding";
import money_rounding from "../../utils/money_rounding";
import { useNavigate } from 'react-router-dom';

const Customerlist = () => {
    const { initState, recaller, setrecaller, clear, initDispatch } =
    useContext(GlobalContext);

    const navigate = useNavigate();

    const [customer_id, setcustomer_id] = useState();
    const [customer_name, setcustomer_name] = useState();
    const [customer_address, setcustomer_address] = useState();
    const [customer_phone, setcustomer_phone] = useState();
    const [show, setshow] = useState(false);
    const [show1, setshow1] = useState(false);

    return (
        <div>
            <Editcustomermodal
                show={show}
                setshow={setshow}
                customer_id={customer_id}
                customer_name={customer_name}
                setcustomer_name={setcustomer_name}
                customer_address={customer_address}
                setcustomer_address={setcustomer_address}
                customer_phone={customer_phone}
                setcustomer_phone={setcustomer_phone}
            />
            <Loanbackmodal show={show1} setshow={setshow1} customer_id={customer_id} />

            {/* Customer List Card */}
            <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto">
                
                {/* Section Header */}
                <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
                    <h2 className="text-base font-semibold text-slate-800">لیستی کڕیار</h2>
                </div>


                {/* Table */}
                <table className="w-full">
                    <thead>
                        <tr className="bg-slate-50 border-b border-slate-100">
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                            ناوی کڕیار
                            </th>
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                            ناونیشان
                            </th>
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                            ژمارەی تەلەفۆن
                            </th>
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                            قەرزی کڕیار
                            </th>
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                            گێڕانەوەی قەرز
                            </th>
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                            گۆڕانکاری
                            </th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-50">
                    {initState.customer.map((lis) => (
                        <tr key={lis.customer_id} className="hover:bg-slate-50 transition-colors duration-100">
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                            <p className={lis.customer_id==1?"text-slate-800 whitespace-nowrap":"text-indigo-600 whitespace-nowrap underline cursor-pointer"}
                                onClick={() =>{
                                    if(lis.customer_id!=1){
                                        initDispatch({type:'setcustomer_ledger', payload:{ledger_customer_id:lis.customer_id, ledger_customer_name:lis.customer_name}});
                                        navigate('/customer/ledger');
                                    }
                                }}
                            >
                                {lis.customer_name}
                            </p>
                        </td>
                        <td className="px-6 py-4 text-sm text-slate-500 text-right">
                            {lis.customer_address}
                        </td>
                        <td className="px-6 py-4 text-sm text-slate-500 text-right">
                            {lis.customer_phone}
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-700 text-right">
                            {lis.customer_id==1?"-":numberbeautify(iqd_rounding(money_rounding(lis.customer_loan)))+" IQD"}
                        </td>
                        <td
                            className="px-6 py-4 text-right"
                        >
                            <button
                                className={
                                lis.customer_id==1
                                    ? "inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-slate-100 text-slate-400 cursor-not-allowed"
                                    : "inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-emerald-50 text-emerald-700 hover:bg-emerald-100 border border-emerald-200 transition-colors cursor-pointer"
                                }
                                disabled={lis.customer_id==1}
                                onClick={() => {
                                    if(lis?.customer_id!=1){
                                        setcustomer_id(lis.customer_id);
                                        setshow1(true);
                                    }
                                }}
                            >
                                گێڕانەوەی قەرز
                            </button>
                        </td>
                        <td className="px-6 py-4 text-right">

                            <button
                                className={
                                lis.customer_id==1
                                    ? "inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-slate-100 text-slate-400 cursor-not-allowed"
                                    : "inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-amber-50 text-amber-700 hover:bg-amber-100 border border-amber-200 transition-colors cursor-pointer"
                                }
                                disabled={lis.customer_id==1}
                                onClick={() => {
                                    if(lis?.customer_id!=1){
                                        setcustomer_id(lis.customer_id);
                                        setcustomer_name(lis.customer_name);
                                        setcustomer_address(lis.customer_address);
                                        setcustomer_phone(lis.customer_phone);
                                        setshow(true);
                                    }
                                }}
                            >
                                گۆڕانکاری
                            </button>
                        </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
                </div>
            </div>
    )
}

export default Customerlist